import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AdminService } from '../../../../../../../services/admin/admin.service';
import { TdLoadingService } from '@covalent/core';

@Component({
  selector: 'app-author-info-dialog',
  templateUrl: './author-info-dialog.component.html',
  styleUrls: ['./author-info-dialog.component.scss']
})
export class AuthorInfoDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<AuthorInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { ideaId: number },
    private adminService: AdminService,
    private _loadingService: TdLoadingService
  ) {}

  ngOnInit() {}
  closeDialog(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/dialogs/author-info-dialog/author-info-dialog.component.ts